import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollTopBehavior from '../components/ScrollTopBehavior'

// Home Page
import ItSolution from '../views/home-pages/ItSolution'

// Inner Pages
import About from '../views/inner-pages/about/About'

// Services
import Services from '../views/inner-pages/services/Services'
import ServicesDetails from '../views/inner-pages/services/ServicesDetails'

// Team
import Team from '../views/inner-pages/team/Team'
import TeamDetails from '../views/inner-pages/team/TeamDetails'

// Pages
import Price from '../views/inner-pages/pages/Price'
import Faq from '../views/inner-pages/pages/Faq'
import Error from '../views/inner-pages/pages/Error'
import Login from '../views/inner-pages/pages/Login'
import Signup from '../views/inner-pages/pages/Signup'
import ComingSoon from '../views/inner-pages/pages/ComingSoon'
import Contact from '../views/inner-pages/pages/Contact'

// Project
import ProjectDetails from '../views/inner-pages/project/ProjectDetails'

// Blog
import BlogGrid from '../views/inner-pages/blog/BlogGrid'

// Fallback
import NotFound from '../views/NotFound'

const AppRouter = () => {
    return (
        <>
            <ScrollTopBehavior />
            <Routes>
                <Route path="/" element={<ItSolution />} />

                {/* About */}
                <Route path="/about" element={<About />} />

                {/* Services */}
                <Route path="/services" element={<Services />} />
                <Route path="/services-details" element={<ServicesDetails />} />

                {/* Team */}
                <Route path="/team" element={<Team />} />
                <Route path="/team-details" element={<TeamDetails />} />

                {/* Pages */}
                <Route path="/price" element={<Price />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/error" element={<Error />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/coming-soon" element={<ComingSoon />} />

                {/* Project */}
                <Route path="/project-details" element={<ProjectDetails />} />

                {/* Blog */}
                <Route path="/blog-grid" element={<BlogGrid />} />

                {/* Contact */}
                <Route path="/contact" element={<Contact />} />

                {/* Fallback */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    )
}

export default AppRouter
